import PropTypes from "prop-types";
import React from "react";
import { Helmet } from 'react-helmet-async';

import { Row, Col, Container, Card, Button } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";


// actions
import { loginUser, apiError, socialLogin } from "../../store/actions";

// import images
import logo from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

const Login = (props) => {
  const { instance } = useMsal();

  const handleRedirect = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: "create",
      })
      .catch((error) => console.log(error));
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Login Braskem RDMS</title>
      </Helmet>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={6} xs={12}>
              <div className="text-center mb-5">
                <Link to="/" className="auth-logo">
                  <img
                    src={logo}
                    alt=""
                    height="28"
                    className="auth-logo-dark"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="28"
                    className="auth-logo-light"
                  />
                </Link>
                <p className="font-size-15 text-muted mt-3">Braskem RDMS</p>
              </div>
              <Card className="overflow-hidden">
                <Row className="g-0">
                  <Col lg={12}>
                    <div className="p-lg-5 p-4">
                      <div>
                        <h5>Sign in to continue to Braskem RDMS.</h5>
                      </div>
                      <div className="mt-4 pt-3">
                        <Button color="primary" onClick={handleRedirect}>Log in</Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error } = state.Login;
  return { error };
};

export default connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login);

Login.propTypes = {
  error: PropTypes.any,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
};
